import React from "react";
import useThemeOptions from "../../hooks/useThemeOptions";
import predefinedFeatures from "./predefined-features";
import customFeatures from "./custom-features";

const FeatureList = () => {
  const {
    companyAccusative,
    companyDative,
    dataPrivacy: { usedFeatures },
  } = useThemeOptions();

  const predefined = predefinedFeatures(companyAccusative, companyDative);
  const custom = customFeatures(companyAccusative, companyDative);

  const featureBlocks = usedFeatures.map((usedFeatureKey) => {
    const predefinedFeature = predefined.find((f) => f.key === usedFeatureKey);
    const customFeature = custom.find((f) => f.key === usedFeatureKey);
    const usedFeature = customFeature || predefinedFeature;
    if (!usedFeature) {
      throw new Error(
        `Could not find any data privacy feature with key: ${usedFeatureKey}`
      );
    }
    return (
      <React.Fragment key={usedFeatureKey}>
        <h2>{usedFeature.title}</h2>
        {usedFeature.body}
      </React.Fragment>
    );
  });

  return featureBlocks;
};

export default FeatureList;
